import {
    ComponentRef,
    Directive,
    Input,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    ViewContainerRef,
    inject,
} from '@angular/core';
import { NgxSpinnerComponent, NgxSpinnerService } from 'ngx-spinner';

@Directive({
    standalone: false,
    selector: '[busyIf]',
})
export class BusyIfDirective implements OnChanges, OnDestroy {
    private static index = 0;

    @Input() busyIf: boolean;

    private readonly ngxSpinnerService = inject(NgxSpinnerService);
    private readonly spinnerName = `busyIfSpinner-${BusyIfDirective.index++}`;
    private spinnerRef: ComponentRef<NgxSpinnerComponent> | null = null;

    constructor(private readonly viewContainer: ViewContainerRef) {
        this.createSpinner();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.busyIf) {
            this.refreshState(!!changes.busyIf.currentValue);
        }
    }

    ngOnDestroy(): void {
        void this.ngxSpinnerService.hide(this.spinnerName);
        this.spinnerRef?.destroy();
        this.spinnerRef = null;
    }

    private createSpinner(): void {
        const hostElement = this.viewContainer.element.nativeElement as HTMLElement;
        if (!hostElement.style.position) {
            hostElement.style.position = 'relative';
        }

        this.spinnerRef = this.viewContainer.createComponent(NgxSpinnerComponent);
        const spinner = this.spinnerRef.instance;
        spinner.name = this.spinnerName;
        spinner.fullScreen = false;
        spinner.bdColor = 'rgba(255, 255, 255, 0.35)';
        spinner.size = 'medium';
        spinner.type = 'ball-clip-rotate';
        spinner.zIndex = 10;
    }

    private refreshState(isBusy: boolean): void {
        if (isBusy) {
            void this.ngxSpinnerService.show(this.spinnerName);
        } else {
            void this.ngxSpinnerService.hide(this.spinnerName);
        }
    }
}
